import React, { useState } from 'react';
import { Modal, ModalHeader, ModalBody, Button, ModalFooter } from 'reactstrap';
import { FormControl, RadioGroup, FormControlLabel, Radio } from '@material-ui/core';
import { showLoading } from '../../../../actions';

export default ({ isOpen, onClose, items, onSave }) => {
    const [conjunto, setConjunto] = useState(null);

    const handleChange = (e) => {
        setConjunto(e.target.value);
    };

    const handleSave = () => {
        if (!conjunto) return;
        showLoading();
        onSave(items, conjunto);
    };

    return (
        <Modal isOpen={isOpen} toggle={onClose}>
            <ModalHeader className='modal-title' style={{ position: 'relative', height: 50 }}>
                <span style={{ position: 'absolute', left: '41%' }}>Conjuntos</span>
            </ModalHeader>
            <ModalBody>
                <FormControl sx={{ m: 3 }} component='fieldset' variant='standard'>
                    <RadioGroup aria-labelledby='conjuntos' defaultValue='' name='conjunto' onChange={handleChange}>
                        <FormControlLabel value='1' name='conjunto' control={<Radio />} label='Aplicar para cima' />
                        <FormControlLabel value='2' name='conjunto' control={<Radio />} label='Aplicar para baixo' />
                    </RadioGroup>
                </FormControl>
            </ModalBody>
            <ModalFooter>
                <Button type='submit' size='md' color='primary' onClick={handleSave}>
                    Salvar
                </Button>
                <Button color='secondary' onClick={onClose}>
                    Cancelar
                </Button>
            </ModalFooter>
        </Modal>
    );
};
